import { render, staticRenderFns } from "./FormGridPanel.vue?vue&type=template&id=07ed84c3&"
import script from "./FormGridPanel.vue?vue&type=script&lang=js&"
export * from "./FormGridPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports